<template>
	<div class="alert_bg">
		<div class="alert_wrap">
			<div class="close_btn" @click="editTaskDone"></div>
			<div class="box_title">编辑下载任务</div>

			<div class="filename_box">
				<div class="file_icon">
					<img :src="file_icon" />
				</div>
				<div class="filename" :title="task.name">{{task.name}}</div>
				<div class="filesize">{{common.formatSize(task.size)}}</div>
			</div>

			<div class="file_type_box">
				<button
					class="default"
					:class="$store.state.editTaskBox.types.includes('default') ? 'isChecked':''"
					@click="isChecked('default')"
				>默认</button>
				<button
					class="check_all"
					:class="$store.state.editTaskBox.types.includes('all') ? 'isChecked':''"
					@click="isChecked('all')"
				>全选</button>
				<button
					class="check_all"
					:class="$store.state.editTaskBox.types.includes(type) ? 'isChecked':''"
					@click="isChecked(type)"
					:key="type"
					v-for="type in $store.state.editTaskBox.fileTypes"
				>{{type}}</button>
			</div>

			<div class="file_box">
				<div class="file_title">
					<!--					<span class="header_right">-->
					<!--						<img :src="right" />-->
					<!--					</span>-->
					<span class="header_name">文件名称</span>
					<span class="header_type">类型</span>
					<span class="header_size">大小</span>
					<span class="header_status">状态</span>
				</div>

				<!-- 树-->
				<div class="tree_box">
					<items
						v-for="(item, index) in $store.state.editTaskBox.filesTree"
						:model="item"
						:key="index"
						:treeIndex="1"
					></items>
				</div>

				<div class="count_file_size">已选{{$store.state.editTaskBox.ids.length}}个文件，共{{file_size}}</div>
			</div>

			<button class="confirm" @click="doEdit">确认</button>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import common from "../../../common/common";
import Items from "@/components/Items.vue";
export default {
	// name: "Home",
	props: ["task"], // 任务信息
	data: function () {
		return {
			common: common,
			file_icon: require("../assets/box_file.png"),
			right: require("../assets/box_right.png"),
			sourceFilesTree: [],
			source_ids: [],
			default_ids: [],
			file_size: 0,
		};
	},
	watch: {
		"$store.state.editTaskBox.ids": function (ids) {
			let _that = this;

			//  1深复制一份sourceFilesTree
			let tree = JSON.parse(JSON.stringify(_that.sourceFilesTree));

			// //如果根没有状态，则继续遍历
			for (let index = 0; index < tree.length; index++) {
				while (tree.three_check_status == undefined) {
					_that.recursion(tree, tree.name, tree);
				}
			}

			// 2赋值给全局的
			_that.$store.state.editTaskBox.filesTree = tree;

			let size = 0;
			let files = _that.$store.state.editTaskBox.files;
			for (let index = 0; index < files.length; index++) {
				for (let j = 0; j < ids.length; j++) {
					if (ids[j] == files[index].id) {
						size += files[index].size;
					}
				}
			}
			_that.file_size = common.formatSize(size);
		},
	},
	components: {
		Items,
	},
	methods: {
		...mapActions(["getTaskSub", "postTaskSub"]),

		isChecked: function (type) {
			//取消
			let _that = this;
			if (_that.$store.state.editTaskBox.types.includes(type)) {
				//从全局中去掉
				_that.$store.state.editTaskBox.types.splice(
					_that.$store.state.editTaskBox.types.indexOf(type),
					1
				);

				//取消全选
				if (type == "all") {
					_that.$store.state.editTaskBox.ids = [];
					return;
				} else if (type == "default") {
					_that.$store.state.editTaskBox.ids = [];
				} else {
					//取消
					let files = _that.$store.state.editTaskBox.files;
					//获取相应类型的ids
					let arr = new Array();
					for (let j = 0; j < files.length; j++) {
						if (files[j].name.indexOf("." + type) != -1) {
							arr.push(files[j].id);
						}
					}

					if (arr.length == 0) {
						return;
					}
					//排除
					_that.ids = JSON.parse(
						JSON.stringify(_that.$store.state.editTaskBox.ids)
					);
					let box = JSON.parse(
						JSON.stringify(_that.$store.state.editTaskBox.ids)
					);
					for (let j = 0; j < _that.ids.length; j++) {
						let flag = false;
						for (let index = 0; index < arr.length; index++) {
							if (_that.ids[j] == arr[index]) {
								flag = true;
							}
						}
						if (flag) {
							box.splice(box.indexOf(_that.ids[j]), 1);
						}
					}
					_that.$store.state.editTaskBox.ids = box;
				}
				//点击
			} else {
				if (type == "default") {
					_that.$store.state.editTaskBox.types = [];
					_that.$store.state.editTaskBox.types.push(type);

					_that.$store.state.editTaskBox.ids = _that.default_ids;
				} else if (type == "all") {
					_that.$store.state.editTaskBox.types = [];
					_that.$store.state.editTaskBox.types.push(type);

					_that.$store.state.editTaskBox.ids = _that.source_ids;
				} else {
					if (
						_that.$store.state.editTaskBox.types.includes("default")
					) {
						_that.$store.state.editTaskBox.types.splice(
							_that.$store.state.editTaskBox.types.indexOf(
								"default"
							),
							1
						);

						_that.$store.state.editTaskBox.ids = [];
					}
					if (_that.$store.state.editTaskBox.types.includes("all")) {
						_that.$store.state.editTaskBox.types.splice(
							_that.$store.state.editTaskBox.types.indexOf(
								"default"
							),
							1
						);
						_that.$store.state.editTaskBox.ids = [];
					}

					// 把点击的元素item放入box数组中
					_that.$store.state.editTaskBox.types.push(type);

					//新增进去
					let files = _that.$store.state.editTaskBox.files;
					let arr = new Array();
					for (let j = 0; j < files.length; j++) {
						if (files[j].name.indexOf("." + type) != -1) {
							arr.push(files[j].id);
						}
					}

					if (arr.length == 0) {
						return;
					}
					_that.ids = JSON.parse(
						JSON.stringify(_that.$store.state.editTaskBox.ids)
					);

					let merge = common.mergeArray(_that.ids, arr);
					//放到全局
					_that.$store.state.editTaskBox.ids = merge;
				}
			}
		},
		editTaskDone: function () {
			let _that = this;
			_that.$emit("editTaskDone");
		},
		doEdit: function () {
			// 提交文件
			let _that = this;
			let editInfo = common.buildUint8Array(
				_that.$store.state.editTaskBox.ids
			);
			console.log("ids", editInfo);


      //一个都没有选中，则不能提交
      if (_that.$store.state.editTaskBox.ids.length == 0) {
        _that.$store.state.alertToast.type = "error";
        _that.$store.state.alertToast.text = "请选择文件";
        return;
      }

			_that.postTaskSub([
				_that.task.taskid,
				editInfo.ids,
				editInfo.start,
				editInfo.len,
				function (err, data) {
					if (err || !data || data.resp.rtn) {
						_that.$store.state.alertToast.type = "error";
						_that.$store.state.alertToast.text = "修改任务信息失败";
						return;
					}
					_that.$store.state.alertToast.type = "success";
					_that.$store.state.alertToast.text = "修改任务信息成功";
					_that.editTaskDone();
				},
			]);
		},
		getFiles: function (cursor, cb) {
			// 请求接口获取文件列表
			let _that = this;
			_that.getTaskSub([
				_that.task.taskid,
				3,
				cursor,
				function (err, data) {
					if (err || !data || data.resp.rtn) {
						_that.$store.state.alertToast.type = "error";
						_that.$store.state.alertToast.text = "获取任务信息失败";
						_that.editTaskDone();
						cb ? cb(err, data) : null;
						return;
					}
					_that.$store.state.editTaskBox.files = _that.$store.state.editTaskBox.files.concat(
						data.sub
					);
					if (data.cursor > -1) {
						_that.getFiles(data.cursor, cb);
					} else {
						cb ? cb(err, data) : null;
					}
				},
			]);
		},
		buildFilesTree: function () {
			// 生成文件树
			let _that = this;
			for (
				let index = 0;
				index < _that.$store.state.editTaskBox.files.length;
				index++
			) {
				const file = _that.$store.state.editTaskBox.files[index];
				if (!file.name) {
					continue;
				}
				let pathArrayTemp = file.name.split("/");
				let fileName = pathArrayTemp[pathArrayTemp.length - 1];
				if (!fileName) {
					continue;
				}
				let pathArray = [];
				for (let j = 0; j < pathArrayTemp.length; j++) {
					const pathName = pathArrayTemp[j];
					if (pathName && pathName != fileName) {
						pathArray.push(pathName);
					}
				}
				file.id = file.id ? parseInt(file.id) : 0;
				file.isFolder = false;
				file.name = fileName;
				_that.checkAndAddFile(pathArray, file);
			}
			console.log(_that.$store.state.editTaskBox.filesTree);
		},
		checkAndAddFile: function (pathArray, file) {
			// 检查文件路径和添加文件
			let _that = this;
			let parentTree = _that.$store.state.editTaskBox.filesTree;

			for (let index = 0; index < pathArray.length; index++) {
				let pathName = pathArray[index];
				let isHasFolder = false;
				for (let j = 0; j < parentTree.length; j++) {
					const path = parentTree[j];
					if (path.name == pathName) {
						isHasFolder = true;
						break;
					}
				}
				if (!isHasFolder) {
					parentTree.push({
						name: pathName,
						isFolder: true,
						child: [],
					});
				}
				for (let j = 0; j < parentTree.length; j++) {
					const path = parentTree[j];
					if (path.name == pathName) {
						parentTree = path.child;
						break;
					}
				}
			}
			if (parentTree.child) {
				parentTree.child.push(file);
			} else {
				parentTree.push(file);
			}
		},
		recursion: function (tree, parentName, parent) {
			let _that = this;
			//通过儿子们的选择状态，得到父亲的选择状态
			let flag1 = 0;
			let flag2 = 0;

			//全选，半选，全不选
			let flag_y = 0;
			let flag_x = 0;
			let flag_z = 0;
			for (let index = 0; index < tree.length; index++) {
				//如果id包含在ids里面
				if (
					!tree[index].isFolder &&
					_that.$store.state.editTaskBox.ids.includes(tree[index].id)
				) {
					flag2++;
					tree[index].three_check_status = "yes";
				} else if (
					!tree[index].isFolder &&
					!_that.$store.state.editTaskBox.ids.includes(tree[index].id)
				) {
					flag1++;
					tree[index].three_check_status = "no";
				}

				// //设置儿子们的选择状态
				// if(tree[index].selected == 1){
				//   flag2++
				//   tree[index].three_check_status = "yes";
				//
				// }else if(tree[index].selected == 0){
				//   flag1++
				//   tree[index].three_check_status = "no";
				// }

				//如果有孩子则继续调用
				if (tree[index].child) {
					//递归调用
					_that.recursion(
						tree[index].child,
						tree[index].name,
						tree[index]
					);
				}

				if (
					tree[index].three_check_status &&
					tree[index].three_check_status == "yes"
				) {
					flag_y++;
				} else if (
					tree[index].three_check_status &&
					tree[index].three_check_status == "no"
				) {
					flag_x++;
				} else if (
					tree[index].three_check_status &&
					tree[index].three_check_status == "half"
				) {
					flag_z++;
				}
			}

			//如果儿子们的状态都是全选，则父亲也要全选

			if (flag_y == tree.length) {
				parent.three_check_status = "yes";
			} else if (flag_x == tree.length) {
				parent.three_check_status = "no";
			} else {
				parent.three_check_status = "half";
			}

			// if (flag2 == tree.length) {
			// 	parent.three_check_status = "yes";
			// }
			// if (flag1 != 0) {
			// 	parent.three_check_status = "half";
			// }

			// if (flag_y == tree.length) {
			// 	parent.three_check_status = "yes";
			// }

			// if (flag_x == tree.length) {
			// 	parent.three_check_status = "no";
			// }

			// if (flag_z != 0) {
			// 	parent.three_check_status = "half";
			// }
		},
	},
	mounted: function () {
		let _that = this;
		_that.$store.state.editTaskBox.files = [];
		_that.$store.state.editTaskBox.filesTree = [];
		_that.$store.state.editTaskBox.fileTypes = [];
		_that.$store.state.editTaskBox.ids = [];

		_that.$store.state.isShowLoading = true;

		_that.getFiles(0, function () {
			_that.$store.state.isShowLoading = false;
			console.log(
				"_that.$store.state.editTaskBox.files",
				JSON.stringify(_that.$store.state.editTaskBox.files)
			);
			for (
				let index = 0;
				index < _that.$store.state.editTaskBox.files.length;
				index++
			) {
				let file = _that.$store.state.editTaskBox.files[index];
				let typeArray = file.name.split(".");
				let type = "";
				if (typeArray.length > 1) {
					type = typeArray[typeArray.length - 1];
				}
				if (
					type &&
					!_that.$store.state.editTaskBox.fileTypes.includes(type)
				) {
					_that.$store.state.editTaskBox.fileTypes.push(type);
				}
				if (file.selected) {
					_that.$store.state.editTaskBox.ids.push(file.id);
				}

				_that.source_ids.push(file.id);
			}
			_that.buildFilesTree();

			// 修复去掉第一层
			if (
				_that.$store.state.editTaskBox.filesTree.length == 1 &&
				_that.$store.state.editTaskBox.filesTree[0].isFolder
			) {
				_that.$store.state.editTaskBox.filesTree =
					_that.$store.state.editTaskBox.filesTree[0].child;
			}

			//保存一份默认
			_that.default_ids = _that.$store.state.editTaskBox.ids;

			//复制一份原始tree
			_that.sourceFilesTree = JSON.parse(
				JSON.stringify(_that.$store.state.editTaskBox.filesTree)
			);

			let tree = _that.$store.state.editTaskBox.filesTree;

			//如果根没有状态，则继续遍历
			for (let index = 0; index < tree.length; index++) {
				while (tree.three_check_status == undefined) {
					_that.recursion(tree, tree.name, tree);
				}
			}
		});

		// 1 选中
		// 0 不选中
	},
};
</script>

<style lang="less" scoped>
.alert_bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 8;
	font-size: 14px;

	.alert_wrap {
		position: absolute;
		width: 600px;
		margin-left: -380px;
		margin-top: -280px;
		top: 50%;
		left: 50%;
		background-color: #ffffff;
		padding: 30px 0;
		border-radius: 6px;
		box-shadow: 2px 2px 8px #666666;
		text-align: center;

		.close_btn {
			position: absolute;
			top: 10px;
			right: 10px;
			width: 20px;
			height: 20px;
			background-image: url(../assets/alert_close_btn.png);
			background-position: center center;
			background-repeat: no-repeat;
			background-size: 15px 15px;
		}

		.close_btn:hover {
			opacity: 0.5;
			cursor: pointer;
		}
		.box_title {
			text-align: center;
			font-size: 14px;
			color: #000000;
		}

		.filename_box {
			display: flex;
			justify-content: flex-start;
			width: 500px;
			margin: auto;
			margin-top: 20px;
			text-align: left;

			.file_icon {
				width: 23px;
				height: 23px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.filename {
				margin-left: 5px;
				width: 400px;
				word-wrap: break-word;
			}

			.filesize {
				margin-left: auto;
			}
		}

		.file_type_box {
			width: 500px;
			height: 80px;
			margin: auto;
			margin-top: 20px;
			border: 2px solid #f0f0f0;
			box-sizing: border-box;
			border-radius: 4px;
			text-align: left;

			button {
				background-color: #f0f0f0;
				color: #666666;
				margin-top: 5px;
				margin-left: 15px;
				width: 60px;
				height: 20px;
				outline: none;
				border: 1px solid #666666;
				border-radius: 3px;
			}

			.isChecked {
				color: #06a8ff;
				background-color: #f6fdff;
				border: 1px solid #06a8ff;
			}
		}

		.file_box {
			position: relative;
			width: 500px;
			height: 180px;
			margin: auto;
			margin-top: 20px;
			border: 2px solid #f0f0f0;
			box-sizing: border-box;
			border-radius: 4px;
			font-size: 13px;
			text-align: left;

			.file_title {
				margin-top: 2px;
				display: flex;
			}

			span {
				width: 75px;
			}

			//.header_right {
			//	margin-left: 5px;
			//	margin-top: 2px;
			//	width: 10px;
			//	height: 10px;
			//
			//	img {
			//		width: 100%;
			//		height: 100%;
			//	}
			//}

			.header_name {
				flex: 1;
				margin-left: 20px;
			}

			.header_status,
			.header_size,
			.header_type {
				text-align: center;
			}

			.tree_box {
				margin-top: 5px;
				width: 100%;
				height: 125px;
				text-align: left;
				overflow-y: scroll;

				-webkit-scrollbar {
					display: none;
				}
			}

			.tree_box::-webkit-scrollbar {
				display: none;
			}

			.count_file_size {
				position: absolute;
				top: 155px;
				height: 25px;
				width: 100%;
				text-align: left;
				line-height: 25px;
				padding-left: 15px;
				background-color: #f0f0f0;
				color: #666666;
				box-sizing: border-box;
			}
		}

		.confirm {
			width: 500px;
			height: 40px;
			margin: auto;
			margin-top: 20px;
			background-color: #06a8ff;
			color: #ffffff;
			outline: none;
		}
	}
}
</style>
